module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Shield-check-13302402263f92d079f450b342d90924.svg";